const FilterType = Object.freeze({
  ALL: {
    value: 'all',
    label: 'All'
  },
  DESKTOP: {
    value: 'desktop',
    label: 'Desktop',
  },
  NOTEBOOK: {
    value: 'notebook',
    label: 'Notebook',
  },
  TESLA: {
    value: 'tesla',
    label: 'Tesla',
  },
  PROVIZ: {
    value: 'proviz',
    label: 'ProViz',
  },
  EMBEDDED: {
    value: 'embedded',
    label: 'Embedded',
  },
  GSYNC: {
    value: 'gsync',
    label: 'Gsync',
  }
})

export {
  FilterType
}
